import './otp-resend-timer.scss';

import { useEffect, useState } from 'react';

export interface IOtpResendTimerProps {
  seconds: number;
  /** Сколько осталось при первом показе (например, после перезагрузки). По умолчанию — seconds. */
  initialSeconds?: number;
  onResend: () => void;
  resendLabel: string;
  countingLabel: (secondsLeft: number) => string;
  disabled?: boolean;
}

export const OtpResendTimer: React.FC<IOtpResendTimerProps> = ({
  seconds,
  initialSeconds,
  onResend,
  resendLabel,
  countingLabel,
  disabled
}) => {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds ?? seconds);

  useEffect(() => {
    if (secondsLeft <= 0) return undefined;
    const id = setInterval(() => setSecondsLeft((prev) => prev - 1), 1000);
    return () => clearInterval(id);
  }, [secondsLeft]);

  const handleResend = () => {
    if (disabled) return;
    onResend();
    setSecondsLeft(seconds);
  };

  if (secondsLeft <= 0) {
    return (
      <button
        type="button"
        className="otp-resend-timer__button"
        onClick={handleResend}
        disabled={disabled}
      >
        {resendLabel}
      </button>
    );
  }

  return (
    <span className="otp-resend-timer__counting">
      {countingLabel(secondsLeft)}
    </span>
  );
};

export default OtpResendTimer;
